import { loginService } from 'src/app/Login/login/login.service';
import { Component, OnInit, ElementRef, ViewChild, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { User } from '../../constants/dfte-user-info';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagingService } from '../../services/messaging.service';
import { BUS_MESSAGE_KEY } from '../../constants/message-bus';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { HttpClient } from '@angular/common/http';
import { DownloadPopupComponent } from '../download-popup/download-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { VideoPopupComponent } from '../video-popup/video-popup.component';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { environment } from 'src/environments/environment';
import { MessageService } from 'src/app/features/dfte-grid-view/services/message.service';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit {
  userData: User = new User();
  private subscription: Subscription;
  public projectid: string;
  public mailDetails: any;
  urlUserId: any;
  showerror: boolean = false;
  userVerified: boolean;
  showSubMenu: boolean = false;
  showPrivacyMenu: boolean = false;
  showCookieMenu: boolean = false;
  showMenu: boolean = false;
  showSupportMenu: boolean = false;
  level3 = false;
  isAdmin: boolean = false; // Added to track if the user is admin
  envrionmentBasicAuth: boolean = false;
  currentUrl: string = '';
  public isPopupOpen: boolean = false;
  public popupPosition = { top: 0, left: 0, right: 0 };

  @ViewChild('userIcon', { static: false }) userIconElement!: ElementRef;
  @ViewChild('popup', { static: false }) popupElement!: ElementRef;
  loggedInAdminUsername: string;
  myBool:any;
  constructor(
    private messagingBus: MessagingService,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    public _data: DataService,
    private router: Router,
    private _https: HttpClient,
    private loginService: loginService,
    private messagingService: MessagingService,
    private messageService: MessageService
  ) {
    
  }
 
  ngOnInit(): void {
    this.envrionmentBasicAuth = environment.isBasicAuth;
   
    const checkIsAdmin = JSON.parse(localStorage.getItem('isAdmin'));
    if (this.envrionmentBasicAuth && checkIsAdmin == 1) {
      this.isAdmin = true;
    }
    this.router.events.subscribe(() => {
      this.currentUrl = this.router.url;
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      const paramKeys = Object.keys(params);
      if (params[paramKeys[1]] !== null && params[paramKeys[1]] !== undefined) {
        this.urlUserId = params[paramKeys[1]];
        this.showerror = false;
        const loggedUser = this._data.loggedUserId.substr(
          0,
          this._data.loggedUserId.length - 13
        );
        if (this.urlUserId !== loggedUser) {
          this.showerror = true;
        }
      }
    });

    this.mailDetails = 'mailto:USIDFTEAdoptionTeam@deloitte.com';

    this.subscription = this.messagingBus.subscribe(
      BUS_MESSAGE_KEY.USER_DETAILS,
      (data) => {
        this.userData = data;
      }
    );

    this.subscription = this.messagingBus.subscribe(
      BUS_MESSAGE_KEY.PRIVACY_STATUS,
      (data: boolean) => {
        this.userVerified = data;
      }
    );
  }

  unmaskPage() {
    this._data.apiCallInProgress = false;
    const overlay = document.getElementById('overlay');
    if (overlay) overlay.style.display = 'none';
  }

  maskPage() {
    this._data.apiCallInProgress = true;
    const overlay = document.getElementById('overlay');
    if (overlay) overlay.style.display = 'block';
  }


  writeContents(content: BlobPart, fileName: string) {
    const a = document.createElement('a');
    const file = new Blob([content]);
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    this._data.downloadStatus = !this._data.downloadStatus;
    a.click();
  }

  // Download user guide
  downloadFile() {
    this.showMenu = !this.showMenu;
    this.showSubMenu = false;
    const url =
      DconConfigAPI.NODE_URL + DconConfigAPI.URL_PROPS.BOT_DOWNLOAD_USER_GUIDE;
    this._data.downloadStatus = false;
    const dialogRef = this.dialog.open(DownloadPopupComponent, {
      width: '500px',
      height: '200px',
    });
    const body = {
      path: this._data.configTemplatePath,
    };
    this._https
      .post(url, body, { responseType: 'arraybuffer' })
      .subscribe((response) => {
        this.writeContents(response, 'User_Guide.docx');
      });
  }

  // Open video popup
  playVideo() {
    this.showMenu = !this.showMenu;
    this.showSubMenu = false;
    this.dialog.open(VideoPopupComponent, {
      width: '840px',
      height: '520px',
    });
  }

  // Toggle the menu visibility
  toggleMenu() {
    this.showMenu = !this.showMenu;
    this.showSubMenu = false;
    this.showSupportMenu = false;
    this.showPrivacyMenu = false;
    this.showCookieMenu = false;
  }

  // Open cookie settings
  openCookieSettings() {
    this.toggleMenu();
    window['Optanon'].ToggleInfoDisplay();
  }

  // Open user popup for user info
  openUserPopup() {
    this.isPopupOpen = true;
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  // Close the user popup
  closeUserPopup() {
    this.isPopupOpen = false;
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

  private handleClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (
      this.isPopupOpen &&
      !this.popupElement.nativeElement.contains(target) &&
      !this.userIconElement.nativeElement.contains(target)
    ) {
      this.closeUserPopup();
    }
  }

  logout() {
    // let token = localStorage.getItem('authToken');
    this.maskPage();

    this.messagingService.publish(BUS_MESSAGE_KEY.LOADER, true);
    this.loginService.logout().subscribe(
      () => {
        this.messageService.showMessage('Logout is Successfull', 'success');
        localStorage.clear();
        this.messagingService.publish(BUS_MESSAGE_KEY.LOADER, false);

        this.unmaskPage();

        this.router.navigate(['/login']);

        window.location.reload();
      },
      (error) => {
        console.log('Unable to Logout', error);
        this.unmaskPage();
      }
    );
  }

  // Navigate to Admin Dashboard
  navigateToAdminDashboard(): void {
    if (this.isAdmin) {
      this.router.navigate(['/admin']);
    } else {
      this.messageService.showMessage('You are not Authorized', 'error');
    }
  }
  logOutButtonEnablement(): boolean {
    if (this.envrionmentBasicAuth && this.currentUrl !== '/login') {
      return true;
    } else {
      false;
    }
  }


  adminDashboardButtonEnablement() {
    const checkIsAdmin = JSON.parse(localStorage.getItem('isAdmin'));
    if (this.envrionmentBasicAuth && checkIsAdmin == 1) {
      this.isAdmin = true;
    }
    
      if (
        this.envrionmentBasicAuth &&
        this.currentUrl !== '/login' &&
        this.isAdmin &&
        this.currentUrl !== '/admin'
      ) {
       return true;
      } else {
        return false;
      }
   
}

  homeScreenRoute() {
    const token = localStorage.getItem('authToken'); 
  
    if (token) {
      this.router.navigate(['/']);
    } else {
      this.messageService.showMessage('You are not authorized', 'error');
    }
  }
}
